import { Entry } from '../Entry'

export function Entry20260205() {
  return (
    <Entry title="2026 Feb 5 - v3.11.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/21655/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
